export default {
  confirmDelete: '削除してもよろしいですか？この操作は元に戻せません',
  confirmLogout: 'ログアウトしてもよろしいですか？',
  saveSuccess: '保存しました',
  saveFailed: '保存に失敗しました',
  deleteSuccess: '削除しました',
  deleteFailed: '削除に失敗しました',
  updateSuccess: '更新しました',
  updateFailed: '更新に失敗しました',
  networkError: 'ネットワークエラー、後でもう一度お試しください',
  serverError: 'サーバーエラー、後でもう一度お試しください',
  timeout: 'リクエストがタイムアウトしました、後でもう一度お試しください',
  addSuccess: '追加しました',
  editSuccess: '編集しました',
  actionSuccess: '操作が成功しました',
  actionFailed: '操作に失敗しました',
  fetchFailed: 'データの取得に失敗しました',
  pleaseSelectProduct: '製品を選択してください',
};
